<template>
  <div>
    <slot></slot>
    <FooterComponent v-if="showFooter" />
  </div>
</template>

<script>
import { computed } from 'vue';
import FooterComponent from '@/Components/FooterComponent.vue';

export default {
  components: {
    FooterComponent,
  },
  setup() {
    return {
      showFooter: computed(() => {
        if (typeof window !== 'undefined') {
          return !window.location.pathname.match(/^\/(clinician\/)?session\/[^/]+$/);
        }
        return true;
      }),
    };
  },
};
</script>
